import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.292 15.7063C11.4731 15.8877 11.7234 16 12 16C12.288 16 12.5475 15.8783 12.73 15.6835L16.7092 11.71C17.0997 11.3195 17.0997 10.6805 16.7092 10.29C16.3187 9.8995 15.6797 9.8995 15.2892 10.29L13 12.5825V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5833L8.71003 10.2901C8.3195 9.89953 7.68054 9.89947 7.29002 10.29C6.8995 10.6805 6.8995 11.3195 7.29003 11.71L11.292 15.7063Z M4 15C3.44772 15 3 15.4477 3 16V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16V19H5V16C5 15.4477 4.55228 15 4 15Z"
  }), '\\\n');
});
var ActionsDownload = AbstractIcon.withComponent(Icon);
ActionsDownload.displayName = 'ActionsDownload';
export default ActionsDownload;